import {create as Lottie} from '@lottiefiles/lottie-interactivity';

const lottie = {
    lottie: undefined,

    cacheLottie: () => {
        lottie.lotties = $('.lottie-animation');
    },

    instantiateLottie: () => {
        if (lottie.lotties.length) {
            $.each(lottie.lotties, function (i, lottiePlayerElement) {
                Lottie({
                    mode:    'scroll',
                    player:  lottiePlayerElement,
                    actions: [
                        {
                            visibility: [0, 1],
                            type:       'seek',
                            frames:     [0, 100]
                        }
                    ]
                });
            });
        }
    }
}

export default lottie;